export default __webpack_public_path__ + "static/media/angle-double-up.1a9786f7.svg";